export default {
    text:
        'Using this contact form you can send a message to the website administrator. The message will be sent instantly and we strive to reply as soon as possible.',
    resellerText: 'purchase a membership through our resellers by contacting us',
    message: 'Message'
}
